import { NumberModel, WhatsappCodeModel } from '@/types';
import BaseService from '@/services/api/BaseService';
import { AxiosRequestConfig } from 'axios';

class WhatsappCodeService extends BaseService<NumberModel> {
    constructor() {
        super('whatsapp-codes');
    }

    getNumbers(config?: AxiosRequestConfig) {
        return this.http.get<NumberModel[]>('/whatsapp-codes/numbers', config);
    }

    getCodes(numberId: number, config?: AxiosRequestConfig) {
        return this.http.get<WhatsappCodeModel[]>(
            `/whatsapp-codes/numbers/${numberId}/codes`,
            config,
        );
    }

    activateRouting(numberId: number, config?: AxiosRequestConfig) {
        return this.http.put<{ message: string; result: unknown }>(
            `/whatsapp-codes/numbers/${numberId}/routing`,
            {},
            config,
        );
    }
}

export default new WhatsappCodeService();
